import $ from 'jquery';
export const tabs = (selector) => {
	$(selector).each((index, element) => {
		const parent = $(element);
		const link = parent.find(`${selector}--link`);
		link.on('click', function (e) {
			e.preventDefault();
			const me = $(this);
			if (me.hasClass('active')) {
				return false;
			}
			parent.find(`${selector}--link.active`).removeClass('active');
			me.addClass('active');
			parent.find(`${selector}--pane.active`).removeClass('active').hide();
			let id = me.attr('href');
			$(id).stop().fadeIn('slow').addClass('active');
		});
	})
}



// WEBPACK FOOTER //
// ./src/scripts/tabs.js